import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { CirculationArea } from 'shell/models/circulation-area';
import { CirculationAreaClient } from 'shell/view-models/circulation-area-client';

export const transformerCirculationArea = (
  response: AxiosResponse<HttpResponse<CirculationArea>>
): CirculationAreaClient => {
  const data = response.data.payload;
  return {
    code: data?.key?.codice,
    description: data?.descrizionePostale || '',
  };
};
